import React from 'react'
import * as PropTypes from 'prop-types'
import clx from 'classnames'
import { observer } from 'mobx-react-lite'
import Translator from '../../translator'

export const NavFooter = observer(function NavFooter(props) {
  return (
    <div className='mtt-modal__footer'>
      <button
        className='button lightgrey small'
        onClick={props.onBack}
        disabled={props.backDisabled}
      >
        {Translator.translate('Tilbage', 'participant')}
      </button>
      <div className='spacer' />
      <button
        className={clx('button blue small', { loading: props.loading })}
        disabled={props.saveDisabled}
        onClick={props.onSubmit}
      >
        {Translator.translate('Gem', 'participant')}
      </button>
    </div>
  )
})

NavFooter.propTypes = {
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  backDisabled: PropTypes.bool
}
